<mat-chip-list class="chip-list">
  <mat-chip *ngFor="let day of event.excludedDays" >

      <span class="btn-icon__text"><a href="{{link(day)}}"> {{ day | date: 'MM/dd/yyyy'}}</a></span>
  </mat-chip>
</mat-chip-list>

